import { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const WifiWarning = (): JSX.Element | null => {
  const [isVisible, setIsVisible] = useState(true);

  return isVisible ? (
    <div className="fixed top-12 md:top-4 left-0 md:left-1/2 transform md:-translate-x-1/2 flex items-center gap-2 p-2 md:p-4 bg-white border-l-4 border-red-500 md:rounded shadow-lg z-50 w-full md:max-w-[90%] md:w-[480px]">
      <div className="text-red-500 flex-shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
          <path d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z" />
        </svg>
      </div>
      <div className="flex-1 text-xs md:text-base font-medium text-gray-800">
        Warning: You are not connected to shop WiFi. Please connect to shop WiFi before checking in.
      </div>
      <button 
        onClick={() => setIsVisible(false)}
        className="flex-shrink-0 text-gray-500 hover:bg-gray-100 hover:text-gray-700 p-1 rounded-full transition-colors" 
        aria-label="Close"
      >
        <XMarkIcon className="w-5 h-5 md:w-6 md:h-6" />
      </button>
    </div>
  ) : null;
};

export default WifiWarning; 